import {
  EligibleItemsQuery,
  SettlementItemPeriodType,
  SettlementItemStatus,
} from '../../../lib/api/settlementDateAdjustment';
import { useEligibleItemsFilter as useSharedEligibleItemsFilter } from '../../settlement/hooks/useEligibleItemsFilter';

/**
 * 기준일 변경은 status=ready 만을 대상으로 한다.
 * 완료일 변경(`['completed']`) 과 명확히 구분되는 기본값.
 *
 * 모듈 스코프 상수로 안정화 — 공유 훅의 `reset` 이 deps 로 가져가므로 매 렌더마다
 * 새 객체면 안 됨.
 */
const INITIAL_FILTER: EligibleItemsQuery = {
  page: 1,
  pageSize: 50,
  statuses: ['ready' as SettlementItemStatus],
  periodTypes: ['daily' as SettlementItemPeriodType],
};

/**
 * 정산 기준일 변경 도메인의 eligible items 필터.
 *
 * 본 훅은 `views/settlement/hooks/useEligibleItemsFilter` 의 도메인 특화 wrapper
 * 다 — 완료일 변경 도메인과 로직 100% 동일하고 `INITIAL_FILTER.statuses` 만 다르다.
 */
export const useEligibleItemsFilter = () =>
  useSharedEligibleItemsFilter<EligibleItemsQuery>(INITIAL_FILTER);
